<script>
export default {
  data () {
    return {
      ok_snackbar: false,
      ok_text: null,
      error_snackbar: false,
      error_text: null,
      query_params: null,
      path_params: null
    }
  },
  mounted () {
    this.query_params = window.th.copy(this.$router.history.current.query);
    this.path_params = window.th.copy(this.$router.history.current.params);
  },
  computed: {

  },
  methods: {
    setQuery (q, v) {
      if (v == null || v.length == 0) {
        if (typeof this.query_params[q] != "undefined") {
          delete this.query_params[q];
        }
      }
      else {
        this.query_params[q] = v;
      }
      this.replaceRoute();
    },
    getQuery (q) {
      if (typeof this.$router.history.current.query[q] != "undefined" && this.$router.history.current.query[q] != null && this.$router.history.current.query[q].toString().length > 0) {
        return this.$router.history.current.query[q];
      }
      return null;
    },
    getQueryInt (q) {
      var v = this.getQuery(q);
      if (v != null && !isNaN(v))
        return parseInt(v);
      return null;
    },
    replaceRoute () {
      var _out_object = {};
      if (typeof this.query_params == "object") {
        var keys = Object.keys(this.query_params);
        keys.forEach((k) => {
          if (this.query_params[k] != null && this.query_params[k].toString().length > 0) {
            _out_object[k] = this.query_params[k].toString();
          }
        })
      }
      this.$router.push({
        name: this.$router.history.current.name,
        params: this.path_params,
        query: Object.keys(_out_object).length > 0 ? _out_object : null
      })
    },
    getQueryObject() {
      var _out_object = {};
      if (typeof this.query_params == "object") {
        var keys = Object.keys(this.query_params);
        keys.forEach((k) => {
          if (this.query_params[k] != null && this.query_params[k].toString().length > 0) {
            _out_object[k] = this.query_params[k].toString();
          }
        })
      }
      return _out_object;
    },
    getQueryString() {
      var _out_object = {};
      if (typeof this.query_params == "object") {
        var keys = Object.keys(this.query_params);
        keys.forEach((k) => {
          if (this.query_params[k] != null && this.query_params[k].toString().length > 0) {
            _out_object[k] = this.query_params[k].toString();
          }
        })
      }
      var str = [];
      for (var p in obj)
        if (_out_object.hasOwnProperty(p)) {
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(_out_object[p]));
        }
      return str.length > 0 ? ("?" + str.join("&")) : "";
    },
    opravneni (check) {
      if (Array.isArray(check)) {
        return check.indexOf(window.$me.opravneni) >= 0;
      }
      else
        return check == window.$me.opravneni;
    },
    ok (t) {
      this.ok_text = t;
      this.ok_snackbar = true;
    },
    error (t) {
      this.error_text = t;
      this.error_snackbar = true;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Base.vue